export function setStepCard(state, res) {
  const { data = {} } = res;
  state.card = data;
}

export function setDocumentList(state, res) {
  const { data = {} } = res;
  state.listDocuments = data.items.map((item) => ({ id: item.id, text: item.name }));
}

export function setLegalSourceList(state, res) {
  const { data = {} } = res;
  state.listLegalSources = data.items.map((item) => ({ id: item.id, text: item.name }));
}

export function setDraftStepCard(state, res) {
  state.draftCard = res;
}
